// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-check-lg::before,
.form-check-lg::after {
  top: 0.4rem !important;
  left: -2rem !important;
  width: 1.25rem !important;
  height: 1.25rem !important;
}

.form-check-lg {
  margin-left: 0.5rem !important;
  font-size: 1.2rem !important;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/radio-list/radio-list.component.scss"],"names":[],"mappings":"AAAA;;EAEE,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;AACF;;AAEA;EACE,8BAAA;EACA,4BAAA;AACF","sourcesContent":[".form-check-lg::before,\n.form-check-lg::after {\n  top: 0.4rem !important;\n  left: -2rem !important;\n  width: 1.25rem !important;\n  height: 1.25rem !important;\n}\n\n.form-check-lg {\n  margin-left: 0.5rem !important;\n  font-size: 1.2rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
